export default __webpack_public_path__ + "static/media/KK_P_Left_Top_a.d65446e0.svg";